const canClick = ( update, onClick ) => {
    if ( update ) {
        return (e) => {
            e.stopPropagation();
            onClick( e );
        }
    }
}

export default canClick;